var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    { attrs: { title: _vm.t("VerifyEmailPage.pageTitle") } },
    [
      _c(
        "sm-form",
        {
          ref: "form",
          attrs: { novalidate: "", model: _vm.formInput, rules: _vm.rules },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("sm-input", {
            attrs: {
              type: "email",
              autofocus: "",
              autocomplete: "email",
              placeholder: _vm.t("VerifyEmailPage.emailPlaceholder"),
              label: _vm.t("VerifyEmailPage.emailLabel"),
            },
            model: {
              value: _vm.formInput.email,
              callback: function ($$v) {
                _vm.$set(_vm.formInput, "email", $$v)
              },
              expression: "formInput.email",
            },
          }),
          _vm._v(" "),
          _c(
            "sm-button",
            {
              staticClass: "block-button",
              attrs: {
                "native-type": "submit",
                type: "primary",
                loading: _vm.loading,
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.t("VerifyEmailPage.submitButton")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.errorMessage
            ? _c("sm-help-card", {
                staticClass: "verify-error",
                attrs: { type: "alert" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n        " + _vm._s(_vm.errorMessage) + "\n      "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  548967452
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }